import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

class VerbParagraph extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        messageId: PropTypes.string,
        defaultMessage: PropTypes.string,
        valuesToInject: PropTypes.object,
        description: PropTypes.string,
        formatIntl: PropTypes.bool,
        customMessage: PropTypes.string
    };

    _formatMessage = (messageId, defaultMessage, description, valuesToInject) => (
        <FormattedMessage
            id={messageId}
            defaultMessage={defaultMessage}
            description={description}
            values={valuesToInject}
        />
    );

    render() {
        const {
            className = '',
            messageId = ' ',
            defaultMessage = ' ',
            valuesToInject = {},
            description = '',
            formatIntl = true,
            customMessage = ''
        } = this.props;

        const messageToRender = formatIntl
            ? this._formatMessage(messageId, defaultMessage, description, valuesToInject)
            : customMessage;
        return <p className={className}>{messageToRender}</p>;
    }
}

export default injectIntl(VerbParagraph);
